// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2fTOt","header":"PatientQuestionnaire_header__2qCxF","info":"PatientQuestionnaire_info__5Oa6x"};